import { render, staticRenderFns } from "./ChangelabelDetail.vue?vue&type=template&id=99ca1e20&scoped=true&"
import script from "./ChangelabelDetail.vue?vue&type=script&lang=js&"
export * from "./ChangelabelDetail.vue?vue&type=script&lang=js&"
import style0 from "./ChangelabelDetail.vue?vue&type=style&index=0&id=99ca1e20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ca1e20",
  null
  
)

export default component.exports